import { getSingleDate, TODAY } from '../../utils/dates';
import sharedFilters from './shared';

const CURRENT_DATE = getSingleDate(TODAY);

export default {
  pageFilters: [
    {
      id: 'content',
      label: 'Content',
      filters: {
        network: null,
        show: null,
        genre: null
        // release_date: null
      }
    },
    {
      id: 'users',
      label: 'Users',
      filters: {
        country: null,
        panel: sharedFilters.sampleBalance,
        age: null,
        gender: null
      }
    },
    {
      id: 'date',
      label: 'Date',
      filters: {
        singleDate: {
          value: CURRENT_DATE
        }
      }
    },
    {
      id: 'segments',
      label: 'Saved Filters',
      filters: {
        segments: sharedFilters.segments
      }
    }
  ],
  looks: {
    anticipatedUnairedShows: {
      fields: [
        'age',
        'country',
        'singleDate',
        'gender',
        'panel',
        'network',
        'show',
        'genre',
        'release_date'
      ],
      showTitle: true
    },
    anticipatedReturningShows: {
      fields: [
        'country',
        'singleDate',
        'panel',
        'network',
        'show',
        'genre',
        'release_date'
      ],
      showTitle: true
    },
    moviesAnticipation: {
      fields: ['age', 'country', 'date', 'gender', 'panel', 'movie', 'genre'],
      showTitle: true
    }
  }
};
